var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscountCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 93H48V90C48 86.6925 45.3075 84 42 84C38.6925 84 36 86.6925 36 90V93H21C16.0375 93 12 88.9625 12 84V36C12 31.0375 16.0375 27 21 27H36V30C36 33.3075 38.6925 36 42 36C45.3075 36 48 33.3075 48 30V27H99C103.963 27 108 31.0375 108 36V84C108 88.9625 103.963 93 99 93ZM53.62 87H99C100.655 87 102 85.655 102 84V36C102 34.345 100.655 33 99 33H53.62C52.285 38.17 47.58 42 42 42C36.42 42 31.715 38.17 30.38 33H21C19.345 33 18 34.345 18 36V84C18 85.655 19.345 87 21 87H30.38C31.715 81.83 36.42 78 42 78C47.58 78 52.285 81.83 53.62 87Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60C54.21 60 49.5 55.29 49.5 49.5C49.5 43.71 54.21 39 60 39C65.79 39 70.5 43.71 70.5 49.5C70.5 55.29 65.79 60 60 60ZM60 45C57.52 45 55.5 47.0175 55.5 49.5C55.5 51.9825 57.52 54 60 54C62.48 54 64.5 51.9825 64.5 49.5C64.5 47.0175 62.48 45 60 45Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 81C79.71 81 75 76.29 75 70.5C75 64.71 79.71 60 85.5 60C91.29 60 96 64.71 96 70.5C96 76.29 91.29 81 85.5 81ZM85.5 66C83.02 66 81 68.0175 81 70.5C81 72.9825 83.02 75 85.5 75C87.98 75 90 72.9825 90 70.5C90 68.0175 87.98 66 85.5 66Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6411 37.153L54.6396 79.1506L59.3574 82.8578L92.3588 40.8601L87.6411 37.153Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountCode);
export default __webpack_public_path__ + "static/media/DiscountCode.d89ca636.svg";
export { ForwardRef as ReactComponent };